/** Settings -> Planning -> Procedure, the role fields and the case variant (Phase 2 P2-2b, P21-P22). */
export default {
  procedure: {
    title: 'Procedure adjustments',
    description:
      'Rename steps, leave out optional steps, set deadlines within the limits the procedure allows and list extra documents. Statutory steps are locked. Cases already open keep the procedure they started with.',
    base: 'Procedure {{id}}, version {{version}}',
    active: 'Adjustments in use: {{hash}}',
    none: 'No adjustments: new cases follow the procedure as published.',
    outdated:
      'These adjustments were made for an older version of the procedure. New cases still use them; save them again to apply them to the current version.',
    unavailable:
      'The adjustments in use cannot be loaded, so no new case can be created. Save them again or use the published procedure.',
    locked: 'Locked (statutory)',
    labelIn: 'Name in {{locale}}',
    stages: 'Steps',
    transitions: 'Actions',
    clocks: 'Deadlines',
    skip: 'Leave this step out',
    durations: 'Deadline length',
    durationRange: 'Between {{min}} and {{max}}',
    durationFixed: 'Fixed by the procedure',
    durationTable: 'A rule table sets it; this value applies when no rule matches.',
    documentTypes: 'Extra documents',
    documentTypesHint: 'Listed on each new case. Uploading them comes in a later release.',
    documentTypeId: 'Code',
    documentTypeLabel: 'Name',
    documentTypeExtensions: 'File types (for example .pdf, .jpg)',
    addDocumentType: 'Add a document',
    removeDocumentType: 'Remove',
    save: 'Save adjustments',
    saving: 'Saving the adjustments…',
    saved: 'Adjustments saved. New cases follow them.',
    deactivate: 'Use the published procedure',
    deactivated: 'New cases follow the published procedure.',
    invalid: 'These adjustments were refused:',
    issues: {
      overlay_base_mismatch: 'The procedure changed after this page was opened. Reload the page and save again.',
      overlay_unknown_element:
        'A step, action or deadline in these adjustments is not in the current procedure. Reload the page and try again.',
      overlay_touches_locked:
        'Locked (statutory) steps, actions and deadlines cannot be renamed or changed, and a step cannot be left out when that would change one of them.',
      overlay_invalid_label: 'Each name needs 1 to 200 characters.',
      overlay_skip_not_optional: 'Only optional steps can be left out.',
      overlay_duration_not_adjustable: 'A deadline the procedure fixes cannot be given another length.',
      overlay_duration_out_of_bounds: 'A deadline length must be a whole number within the range shown under it.',
      overlay_document_type_invalid:
        'Each extra document needs a code of 2 to 40 lowercase letters, digits or underscores that starts with a letter (for example site_photos) and is not already used, a name, and 1 to 10 file types such as .pdf. At most 20 extra documents.',
    },
    download: 'Download the procedure:',
    downloadJson: 'JSON file',
    downloadBpmn: 'BPMN 2.0 diagram',
    downloadDmn: 'DMN 1.3 rule tables',
    loadFailed: 'The procedure could not be loaded.',
    caseDocumentTypes: 'Documents this procedure asks for: {{list}}',
  },
  roles: {
    groupsFor: 'Groups for the {{role}} role',
    hint: 'Members with the admin or publisher role act in this role wherever the procedure names it.',
  },
} as const
